<template>
  <!-- filter-common  .fc -->
  <div class="fc">
    <div class="fc-item">
      <div class="fc-item-title">一级分类：</div>
      <div class="fc-item-content" :class="{open: show}">
        <div class="fcc-brand s-red">全部</div>
        <div
          class="fcc-brand"
          v-for="(item, index) in level1List"
          :key="'level1List-' + index"
        >{{item}}</div>
      </div>
      <div class="fc-item-tool">
        <span @click="show=true" v-if="!show">
          查看全部
          <Icon type="ios-arrow-down" />
        </span>
      </div>
    </div>
    <div class="fc-line"></div>
    <div class="fc-item s-1">
      <div class="fc-item-title">二级分类：</div>
      <div class="fc-item-content" :class="{open: show2}">
        <div class="fcc-brand s-red">全部</div>
        <div class="fcc-brand" v-for="(item, index) in level2List" :key="'level2List-' + index">{{item}}</div>
      </div>
      <div class="fc-item-tool">
        <span @click="show2=true" v-if="!show2 && level2List.length > 20">
          查看全部
          <Icon type="ios-arrow-down" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 类别筛选
  name: "filter-common2",
  data() {
    return {
      show: false,
      show2: false,
      level1List: [
        "手术器械01;02;03;04",
        "放射治疗器械05",
        "医用成像器械06",
        "医用诊察和监护器械07",
        "呼吸、麻醉和急救器械08",
        "物理治疗器械09",
        "输血、透析和体外循环器械10",
        "医疗器械消毒灭菌器械11",
        "植入器械12;13",
        "注输、护理和防护器械14",
        "患者承载器械15",
        "眼科器械16",
        "眼科器械17",
        "眼科器械18"
      ],
      level2List: [
        "超声手术设备及附件01-01",
        "2号馆",
        "3号馆",
        "4号馆",
        "5-6号链接馆",
        "7号馆",
        "8号馆"
      ]
    };
  },
  components: {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.fc {
  min-height: 140px;
  background-color: #fff;
  padding: 20px 20px 0;
  &-item {
    &.s-1 {
      margin-top: 19px;
    }
    border-bottom: 1px dotted #bfbfbf;
    display: flex;
    &-title {
      width: 70px;
      color: #808080;
    }
    &-content {
      &.open {
        max-height: initial !important;
        overflow: initial;
      }
      flex: 1;
      max-height: 76px;
      overflow: hidden;
      .fcc-brand {
        display: inline-block;
        margin-right: 38px;
        margin-bottom: 17px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        &.selected {
          color: #d13119;
        }
      }
    }
    &-tool {
      font-size: 14px;
      color: #666;
      width: 80px;
      text-align: right;
      display: flex;
      span {
        align-self: flex-end;
        margin-bottom: 17px;
        cursor: pointer;
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
.s-red {
  color: #d13119 !important;
}
</style>
